import React from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";
import { GroupAssignmentResult } from "api/types";
import { DedupedTopics } from "./DedupedTopics";
import { AssignmentCurriculumDisplay } from "./AssignmentCurriculumDisplay";

export const asgmtDetailsStyle = StyleSheet.create({
	container: {
		position: "absolute",
		top: 210,
		paddingHorizontal: 50,
	},
	title: {
		fontFamily: "Inter",
		fontStyle: "normal",
		fontWeight: "bold",
		fontSize: 32,
		marginBottom: 10,
	},
	assignmentContainer: {
		marginBottom: 30,
		backgroundColor: "#E9F0F1",
		borderRadius: 8,
		paddingLeft: 6,
		paddingRight: 44,
	},
	assignmentName: {
		position: "relative",
		fontFamily: "Inter",
		fontStyle: "normal",
		fontWeight: "semibold",
		fontSize: 20,
	},
	topicContainer: {
		flexDirection: "row",
	},
	topicIcon: {
		width: "15%",
		marginRight: 1,
	},
	assignmentEntryContainer: {
		flexDirection: "row",
		marginBottom: 5,
	},
	assignmentEntryName: {
		position: "relative",
		fontFamily: "Inter",
		fontStyle: "normal",
		fontWeight: "semibold",
		fontSize: 13,
		width: 140,
	},
	assignmentEntryContent: {
		fontFamily: "Inter",
		fontStyle: "normal",
		fontWeight: "normal",
		fontSize: 12,
		textAlign: "justify",
		marginLeft: 16,
		width: 494,
	},
	assignmentCurriculumContainer: {
		marginLeft: 16,
		flexDirection: "column",
	},
	assignmentCurriculumEntry: {
		flexDirection: "row",
		width: 494,
		marginBottom: 12,
	},
	assignmentCurriculumName: {
		fontFamily: "Inter",
		fontStyle: "normal",
		fontWeight: "medium",
		fontSize: 14,
		width: 250,
	},
	assignmentCurriculumCode: {
		fontFamily: "Inter",
		fontStyle: "normal",
		fontSize: 13,
		marginLeft: 50,
		width: 194,
	},
});

interface GroupAssignmentDetailsProps {
	data: GroupAssignmentResult[];
}

export const GroupAssignmentResultsContent: React.FC<
	GroupAssignmentDetailsProps
> = ({ data }): JSX.Element => {
	return (
		<View style={asgmtDetailsStyle.container}>
			<Text style={asgmtDetailsStyle.title}>Assignments</Text>
			{data === null && (
				<Text
					style={{
						fontFamily: "Inter",
						fontStyle: "normal",
						fontWeight: "semibold",
						fontSize: 16,
					}}
				>
					THERE IS NO RECORDED ASSIGNMENT RESULT
				</Text>
			)}

			{data &&
				data.map((asstRes, i) => (
					<View key={i} style={asgmtDetailsStyle.assignmentContainer}>
						<Text style={asgmtDetailsStyle.assignmentName}>
							{asstRes.assignmentDetails.name}
						</Text>
						<DedupedTopics activities={asstRes.assignmentDetails.activities} />
						<View style={asgmtDetailsStyle.assignmentEntryContainer}>
							<Text style={asgmtDetailsStyle.assignmentEntryName}>
								Learning Intention
							</Text>
							<Text style={asgmtDetailsStyle.assignmentEntryContent}>
								Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
								eiusmod tempor incididunt ut labore et dolore magna aliqua.{" "}
							</Text>
						</View>
						<View style={asgmtDetailsStyle.assignmentEntryContainer}>
							<Text style={asgmtDetailsStyle.assignmentEntryName}>
								Year Level
							</Text>
							<Text style={asgmtDetailsStyle.assignmentEntryContent}>
								3, 4, 5{" "}
							</Text>
						</View>
						<View style={asgmtDetailsStyle.assignmentEntryContainer}>
							<Text style={asgmtDetailsStyle.assignmentEntryName}>
								Australian Curriculum
							</Text>
							<AssignmentCurriculumDisplay currList={asstRes.curriculumList} />
						</View>
					</View>
				))}
		</View>
	);
};
